import React, { useEffect } from 'react';

import {
    authSsoNoPbLoginAction,
    loginAction,
} from '../../redux/actions/authActions';
import { AuthSsoResponse, LoginActionResponse } from '../../redux/actions/authActions/types';

import {} from './SsoAuth.styles';
import { useAppDispatch } from '../../hooks/redux';

const SsoAuth: React.FC = () => {
    const params = new URLSearchParams(location.search);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (codeUrl && codeUrl !== '') {
            ssoAuth(codeUrl, stateUrl);
        }
    }, []);

    const codeUrl = params.get('code');
    const stateUrl = params.get('state');

    const ssoAuth = async (code: string, state: string) => {

        let ssoLoginPath = '/login?sso-login=true';
        const { payload } = (await dispatch(
            authSsoNoPbLoginAction({ code: code, state: state }),
        )) as AuthSsoResponse;

        if (!payload || !payload.user) {
            if (payload.errorMessage) {
                ssoLoginPath += `&errorMessage=${encodeURIComponent(payload.errorMessage)}`;
            }

            document.location.href = ssoLoginPath;
            return;
        }

        const data = { userName: state, ssoToken: payload.user };
        const { payload: payloadLogin } = (await dispatch(
            loginAction({ ...data, userName: data.userName.trim(), ssoToken: payload.user }),
        )) as LoginActionResponse;

        if (payloadLogin?.user) {
            document.location.href = '/dashboard';
        } else {
            document.location.href = ssoLoginPath;
        }
    };

    return <></>;
};

export default SsoAuth;
